import { apiFetch } from 'utils/apiFetch'

export const serviceCenterLuresGet = async (deactivated = false) =>
  await apiFetch({
    url: '/service-center-lures-get',
    body: { deactivated },
  })
